// Wallet Dashboard Icon - Exact 48x48 icon from Figma
const DashboardIcon = () => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M31.8125 14C32.332 14 32.75 14.4799 32.75 15.0714C32.75 15.6629 32.332 16.1429 31.8125 16.1429H17.4375C16.5746 16.1429 15.875 16.9424 15.875 17.9286V30.0714C15.875 31.058 16.5746 31.8571 17.4375 31.8571H30.5625C31.4258 31.8571 32.125 31.058 32.125 30.0714V22.2143C32.125 21.2277 31.4258 20.4286 30.5625 20.4286H18.6875C18.168 20.4286 17.75 19.9509 17.75 19.3571C17.75 18.7634 18.168 18.2857 18.6875 18.2857H30.5625C32.4609 18.2857 34 20.0446 34 22.2143V30.0714C34 32.2411 32.4609 34 30.5625 34H17.4375C15.5391 34 14 32.2411 14 30.0714V17.9286C14 15.7589 15.5391 14 17.4375 14H31.8125ZM27.75 26.1429C27.75 25.3527 28.3086 24.7143 29 24.7143C29.6914 24.7143 30.25 25.3527 30.25 26.1429C30.25 26.933 29.6914 27.5714 29 27.5714C28.3086 27.5714 27.75 26.933 27.75 26.1429Z"
      fill="white"
    />
  </svg>
);

export const MENU_ITEMS = [
  {
    key: "dashboard",
    label: "Dashboard",
    to: "/",
    icon: DashboardIcon,
  },
];
